<template>
  <div :class="wrapperClass" :style="wrapperStyle">
    <!-- DESKTOP -->
    <div
      v-if="!$is_tablet_lower_view"
      class="bg-white my-2 border rounded-4 box-shadow-main">
      <div class="p-3 rounded-top-4 bg-top-black">
        <p class="mb-0 body-2-2 font-semibold text-16 text-white">
          {{ $t('hotel.reservation-summary') }}
        </p>
        <p
          class="mb-0 body-2-2 font-bold text-20 text-white"
          :class="{
            'mb-2':
              getBeCartRoom.length > 0 &&
              getMerchant.additional_appearance === 'CART',
          }">
          {{ getMerchant.name }}
        </p>
        <!-- <p class="mb-0 body-2-2" v-if="getBeCartRoom.length == 0">0 {{$t('hotel.guests.guests')}}, 0 {{$t('hotel.rooms')}}</p> -->
        <template v-if="getMerchant.additional_appearance === 'CART'">
          <p
            class="mb-0 body-2-2 font-semibold text-white"
            v-if="getBeCartRoom.length > 0">
            {{ cartTotalGuest }} {{ $t('hotel.guests.guests') }},
            {{ getBeCart.qty.room_rate }}
            {{ $t('hotel.unit-type.' + getBeRoomTypeSummaryType + '.unit') }},
            {{ cartTotalDate }} {{ $t('hotel.night') }}
          </p>
        </template>
      </div>
      <div
        class="bg-light px-3 border-bottom"
        v-for="(cart_list, index) in getBeCartRoom">
        <div class="row no-gutters py-3">
          <div class="col-7 text-left">
            <p class="mb-0 body-3">{{ cart_list.room_rate.name }}</p>
            <p class="mb-0 body-2-4">
              {{ cart_list.room_rate.room_type.name }}
            </p>
            <p class="mb-0 body-3">
              {{ $printTotalGuestPerRoom(cart_list) }}
            </p>
          </div>
          <div class="col-5 text-right">
            <p class="mb-0 text-14 font-lato mb-1 text-semi-dark">
              {{ $formatCurrency($calculateSubTotalPerRoom(cart_list)) }}
            </p>
            <p class="mb-0 body-3">
              {{ cart_list.qty }}
              {{
                $t(
                  'hotel.unit-type.' +
                    cart_list.room_rate.room_type.type +
                    '.units'
                )
              }}
            </p>
            <p
              class="mb-0 body-3-3-2 text-danger underline cursor-pointer"
              @click="removeRoomRate(cart_list)">
              {{ $t('hotel.remove') }}
            </p>
          </div>
        </div>
      </div>
      <div class="p-3 border-b-semi-grey" v-if="isUnderSearchPax">
        <div
          class="w-100 p-3 text-center border"
          style="
            background-color: rgb(255, 246, 243);
            border-color: rgb(254, 207, 184) !important;
          ">
          <p class="mb-0 body-2-1">
            {{ isUnderSearchPax }}
          </p>
        </div>
      </div>
      <ProductAdditional page="SEARCH" />
      <div class="p-3 border-b-semi-grey" v-if="showWarningRequiredRoom">
        <div
          class="w-100 p-3 text-center border"
          style="
            background-color: rgb(255, 246, 243);
            border-color: rgb(254, 207, 184) !important;
          ">
          <p class="mb-0 body-2-1">
            The product you selected requires a room booking. Please choose a
            room in the "Room" tab.
          </p>
        </div>
      </div>
      <div class="pt-0 px-3 py-3">
        <div class="row">
          <div class="col-4">
            <p class="mb-0 body-2-2 font-semibold text-16">
              {{ $t('hotel.total') }}
            </p>
          </div>
          <div class="col-8 text-right">
            <p class="mb-0 body-2-2 font-bold text-18">
              {{ $formatCurrency(totalPrice) }}
            </p>
          </div>
        </div>
        <div class="w-100" v-if="showPreviewCart">
          <div v-if="disabledReservationButton || showWarningRequiredRoom">
            <button
              v-b-tooltip="isUnderSearchPax"
              class="button-secondary py-2 mt-3 w-100 button-disabled">
              {{ $t('hotel.reservation') }}
            </button>
          </div>
          <template v-else>
            <div @click="postLog()">
              <router-link :to="'/' + getMerchant.code + '/cart'">
                <button class="button-secondary py-2 mt-3 w-100">
                  {{ $t('hotel.reservation') }}
                </button>
              </router-link>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- MOBILE -->
    <template v-if="$is_tablet_lower_view && showPreviewCart">
      <p
        v-if="isUnderSearchPax"
        class="mb-2 body-2-1 text-danger w-100 text-center">
        {{ isUnderSearchPax }}
      </p>
      <p
        v-if="showWarningRequiredRoom"
        class="mb-2 body-2-1 text-danger w-100 text-center">
        The product you selected requires a room booking
      </p>
      <div
        class="w-100 bg-green radius-6 d-flex align-items-center justify-content-between py-2 pl-3 pr-2">
        <div @click="toggleDetail(true)" class="flex-fill">
          <p class="mb-0 body-2-2 font-bold text-14 text-white">
            {{ $formatCurrency(totalPrice) }}
          </p>
          <p class="mb-0 body-2 font-regular text-light">
            {{ $t('hotel.detail') }}
          </p>
        </div>
        <div>
          <router-link
            :to="'/' + getMerchant.code + '/cart'"
            :class="{
              'total-disabled':
                disabledReservationButton || showWarningRequiredRoom,
            }"
            @click.native="
              disabledReservationButton || showWarningRequiredRoom
                ? $event.preventDefault()
                : null
            ">
            <button
              @click="postLog()"
              type="button"
              class="button-primary text-right text-14 w-100 pl-3 pr-2">
              {{ $t('hotel.reservation')
              }}<img
                src="../../../assets/img/icon/back-white.png"
                class="ml-1 position-relative transform-180"
                style="top: -1px"
                width="18" />
            </button>
          </router-link>
        </div>
      </div>

      <popup-detail
        id_ref="detail-preview-cart"
        direction="bottom"
        :show="showDetail"
        use_max_size
        use_footer
        wrapper_size="mobile"
        title="Reservation Summary"
        @close="toggleDetail">
        <template v-slot:body>
          <div class="w-100 border-t-form" style="min-height: 30vh">
            <div
              class="px-3 border-b-form"
              v-for="(cart_list, index) in getBeCartRoom">
              <div class="row no-gutters py-3">
                <div class="col-7 text-left">
                  <p class="mb-0 body-2 text-12">
                    {{ cart_list.room_rate.name }}
                  </p>
                  <p class="mb-0 body-2-2 font-semibold text-12">
                    {{ cart_list.room_rate.room_type.name }}
                  </p>
                  <p class="mb-0 body-3">
                    {{ cart_list.room_rate.rate.guest_included }} person /
                    {{
                      $t(
                        'hotel.unit-type.' +
                          cart_list.room_rate.room_type.type +
                          '.per-unit'
                      )
                    }}
                  </p>
                </div>
                <div class="col-5 text-right">
                  <p class="mb-0 body-2-2 text-12 font-semibold">
                    {{ $formatCurrency($calculateSubTotalPerRoom(cart_list)) }}
                  </p>
                  <p class="mb-0 body-2-2 text-12">
                    {{ cart_list.qty }}
                    {{
                      $t(
                        'hotel.unit-type.' +
                          cart_list.room_rate.room_type.type +
                          '.units'
                      )
                    }}
                  </p>
                  <p
                    class="mb-0 body-2-2 text-10 text-orange underline cursor-pointer"
                    @click="removeRoomRate(cart_list)">
                    {{ $t('hotel.remove') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="p-3 border-b-semi-grey" v-if="isUnderSearchPax">
              <div
                class="w-100 p-3 text-center border"
                style="
                  background-color: rgb(255, 246, 243);
                  border-color: rgb(254, 207, 184) !important;
                ">
                <p class="mb-0 body-2-1">
                  {{ isUnderSearchPax }}
                </p>
              </div>
            </div>
            <ProductAdditional bg-color="bg-white" page="SEARCH" />
            <div class="p-3 border-b-semi-grey" v-if="showWarningRequiredRoom">
              <div
                class="w-100 p-3 text-center border"
                style="
                  background-color: rgb(255, 246, 243);
                  border-color: rgb(254, 207, 184) !important;
                ">
                <p class="mb-0 body-2-1">
                  The product you selected requires a room booking. Please
                  choose a room in the "Room" tab.
                </p>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:footer>
          <div class="pt-0 px-3 py-2 border-t-form">
            <div class="row mb-2">
              <div class="col-4">
                <p class="mb-0 body-2-2 font-semibold text-16">
                  {{ $t('hotel.total') }}
                </p>
              </div>
              <div class="col-8 text-right">
                <p class="mb-0 body-2-2 font-bold text-18">
                  {{ $formatCurrency(totalPrice) }}
                </p>
              </div>
            </div>
            <div v-if="disabledReservationButton || showWarningRequiredRoom">
              <button
                v-b-tooltip="`${isUnderSearchPax}`"
                class="button-secondary py-2-5 w-100 button-disabled">
                {{ $t('hotel.reservation') }}
              </button>
            </div>
            <template v-else>
              <div @click="postLog('SEARCH', 'Clicked Reservation')">
                <router-link :to="'/' + getMerchant.code + '/cart'">
                  <button class="button-secondary py-2-5 w-100">
                    {{ $t('hotel.reservation') }}
                  </button>
                </router-link>
              </div>
            </template>
          </div>
        </template>
      </popup-detail>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import ProductAdditional from './additionalService/ProductCart.vue';

export default {
  components: {
    ProductAdditional,
  },
  props: {
    module: {
      type: String,
      default: 'ROOM',
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDetail: false,
    };
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'getBeCartRoom',
      'getBeFilter',
      'getBeCart',
      'getBeRoomTypeSummaryType',
      'getBeRoomTotal',
      'getBeAddtServiceSubTotal',
      'isUnderSearchPax'
    ]),
    totalAdditionalService() {
      return this.getBeAddtServiceSubTotal + this.$totalAddtServiceModule();
    },
    totalGreenTax(){
      const { deposit, pay_later } = this.$greenTaxes();
      return deposit + pay_later;
    },
    totalRoomPrice(){
      const { search_room_is_show_tax_fee_note: showTaxes } = this.getMerchant;
      return showTaxes ? this.getBeRoomTotal + this.totalGreenTax : this.getBeRoomTotal;
    },
    showPreviewCart(){
      const roomIsExist = this.$isNotEmptyV2(this.getBeCartRoom);
      return roomIsExist || this.totalAdditionalPriceShow > 0
    },
    totalAdditionalPriceShow(){
      const { additional_appearance } = this.getMerchant;
      if(additional_appearance !== 'SEARCH_ROOM') return 0;

      return this.getBeAddtServiceSubTotal + this.$totalAddtServiceModule();
    },
    totalPrice(){
      return this.getBeRoomTotal + this.totalAdditionalPriceShow
    },
    wrapperClass() {
      if (this.$is_tablet_lower_view) {
        return this.showPreviewCart ? 'w-100 position-fixed bg-white border-t-form z-index-1040 p-2-5' : '';
      } else {
        let cssClass = 'sticky mb-2';
        if (this.module === 'ADDITIONAL') return cssClass;

        const {
          header_scroll = null,
          show_rate = null,
          show_rate_breakdown = null,
        } = this.config;

        if (
          this.$isEmpty(header_scroll) ||
          this.$isEmpty(show_rate) ||
          this.$isEmpty(show_rate_breakdown)
        )
          return '';

        const isTop5 =
          (!header_scroll || show_rate || show_rate_breakdown) &&
          this.getMerchant.booking_engine_header_type == 'BANNER';
        const isTop90 =
          (!header_scroll || show_rate || show_rate_breakdown) &&
          this.getMerchant.booking_engine_header_type == 'NAVBAR';

        if (isTop5) cssClass += ' top-5';
        if (isTop90) cssClass += ' top-90';
        return cssClass;
      }
    },
    wrapperStyle() {
      if (this.$is_tablet_lower_view) {
        return 'bottom:0px;left:0;';
      } else {
        if (this.module === 'ROOM') return 'top: 165px;';
        return '';
      }
    },
    cartTotalGuest() {
      const { adult, child, infant } = this.getBeFilter.guest;
      let totalGuest = parseInt(adult) + parseInt(child) + parseInt(infant);
      return parseInt(totalGuest);
    },
    cartTotalDate() {
      var diff = 0;
      const { check_in, check_out } = this.getBeFilter.date;
      let checkInFormatted = moment(check_in).format('YYYY-MM-DD');
      let checkOutFormatted = moment(check_out).format('YYYY-MM-DD');
      diff =
        moment(checkOutFormatted).diff(moment(checkInFormatted)) /
        (1000 * 3600 * 24);
      return diff;
    },
    disabledReservationButton() {
      if (this.getBeRoomTotal > 0) {
        return (
          this.getMerchant.use_total_max_guest_restriction &&
          this.$isNotEmptyV2(this.isUnderSearchPax)
        );
      }
      return false;
    },
    showWarningRequiredRoom() {
      return (
        this.getMerchant.additional_appearance === 'SEARCH_ROOM' &&
        this.getBeAddtServiceSubTotal > 0 &&
        this.getBeRoomTotal === 0
      );
    },
  },
  watch: {
    totalPrice(newTotal, oldTotal) {
      if (
        this.$is_tablet_lower_view &&
        this.showDetail &&
        newTotal === 0 &&
        oldTotal > 0
      ) {
        this.toggleDetail();
      }
    },
  },
  methods: {
    ...mapMutations(['beRemoveRoomRate', 'changeBeRoomAvbl']),
    removeRoomRate(cart) {
      const { id, room_type } = cart.room_rate;

      this.beRemoveRoomRate(id);
      const roomTypeParams = {
        id: room_type.id,
        rr_id: id,
        qty: cart.qty,
        action: 'inc',
        is_virtual: room_type.is_virtual,
        availability_affected: room_type.availability_affected,
      };
      this.changeBeRoomAvbl(roomTypeParams);
    },
    postLog() {
      this.$postLog('SEARCH', 'Clicked Reservation');
      if (this.$isEmpty(this.getMerchant.google_analytics_id)) return;
      this.$gtag('event','goto_cart', { method: 'Google' });
    },
    toggleDetail(show = false) {
      this.showDetail = show;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/SearchPreviewCart.vue